import { documents } from '../Providers/API';
import { QuoteDocument } from 'types/document.type';

export function getQuoteDocumentStorageUrl(d: QuoteDocument) {
    return documents.retrieveDocumentWithFileName(d.uuid, d.fileName);
}
